import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
    Form,
    Input,
    Switch,
    Row,
    Col,
    Button,
    Tabs,
    Table,
    Modal,
    Radio,
    Space,
    message
} from 'antd';
import { incomeViewRequest } from '../../api/api'

const { TabPane } = Tabs;
const FormItem = Form.Item;
const Search = Input.Search;



const StoreValue = () => {
    const { state } = useLocation();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [radioValue, setRadioValue] = useState(1);
    const [list, setList] = useState([])
    const [data, setData] = useState(null)
    const { search } = useLocation()
    let navigate = useNavigate();
    useEffect(() => {
        console.log(state);
        getIncomeView()
    }, [])

    const onChange = (checked) => {
        if (checked == '') {
            getIncomeView()
        }

        if (checked == 1) {
            getIncomeView({
                type: 0,
            })
        }
        if (checked == 2) {
            getIncomeView({
                busiType: 11,
            })
        }
        if (checked == 3) {
            getIncomeView({
                busiType: 17,
            })
        }

    };

    const columns = [
        {
            title: '时间',
            dataIndex: 'createTime',
            key: 'createTime',
        },
        {
            title: '订单类型',
            dataIndex: 'busiType',
            key: 'busiType',
        },
        {
            title: '金额(元)',
            dataIndex: 'amount',
            key: 'amount',
            render: (text, row) => {
                return (
                    <div>
                        {row.type == 0 ? <span style={{ color: '#0FAF09' }}>+{row.amount}</span> : <span style={{ color: '#AF0909' }}>-{row.amount}</span>}
                    </div>
                )
            }
        },
        {
            title: '余额(元)',
            dataIndex: 'afCaBalance',
            key: 'afCaBalance',
        },
        {
            title: '订单编号｜支付单号',
            key: 'orderNo',
            dataIndex: 'orderNo',
            render: (text, row) => {
                return (
                    <div>
                        <div>{row.orderNo}</div>
                        <div style={{ color: '#969799' }}>{row.thirdTradeNo}</div>
                    </div>
                )
            }
        },
    ];
    const getIncomeView = (data) => {
        (async _ => {
            return await incomeViewRequest(
                {
                    ...data,
                    merchantCode: localStorage.merchantCode,
                    superMerchantCode: localStorage.appid,
                    pageSize: 10,
                    currentPage: 1,
                }
            );
        })().then(res => {
            if (res.code == 0) {
                setList(res.data.list)
                setData(res.data)
            } else {
                message.error(res.msg)
            }
        });
    }

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const radioChange = (e) => {
        setRadioValue(e.target.value);
    };
    const goWithdrawalRecord = () => {
        navigate('/ws/balance/withdrawal', { replace: false, state: { defaultActiveKey: 2, tag: 1, } })
    }
    const goWithdrawal = () => {
        navigate('/ws/balance/withdrawal', { replace: false, state: { defaultActiveKey: 1, radio: 1, tag: 1, ...state } })
    }
    return (
        <div style={{ height: '100vh', background: '#ffffff', paddingBottom: 20 }}>

            <Row align='middle' style={{ padding: 16, marginTop: 10, borderBottom: '1px solid #EBEDF0' }}>
                <Row align='middle' style={{ padding: '10px 10px', width: '100%', height: '100%', background: '#F7F8FA' }}>
                    <div style={{ background: '#145BD5', height: 14, width: 3, }}></div><div style={{ marginLeft: 10, fontWeight: 500 }}>收益余额</div>
                </Row>
            </Row>
            <Row style={{ background: '#F7F8FA', padding: 20, margin: 16 }}>
                <Col span={6}>
                    <div>
                        <span>收益账户余额(元)</span>
                        <Button type='link' onClick={goWithdrawalRecord}>提现记录</Button>
                    </div>
                    <Row align='middle' style={{ marginTop: 10 }}>
                        <span style={{ fontSize: 24, fontWeight: 500 }}>{data && data.incomeBalance}</span>
                        <Button style={{ marginLeft: 20 }} type="primary" onClick={goWithdrawal}>提现</Button>
                    </Row>

                </Col>
                <Col span={4}>
                    <div>
                        <span>不可用余额(元)</span>
                        <Button style={{ marginLeft: 20 }} type="link" onClick={()=>{
                                navigate('/ws/balance/availableAndAvailable', { replace: false, state: { tag: 1, ...state }, })
                        }}>明细</Button>
                    </div>
                    <div style={{ fontSize: 24, fontWeight: 500, marginTop: 10 }}>{data && data.freezenBalance}</div>
                </Col>
                {/* <Col span={4}>
                    <div><span>今日入账(元)</span></div>
                    <div style={{ fontSize: 24, fontWeight: 500, marginTop: 10 }}>{data && data.freezenBalance}</div>
                </Col>
                <Col span={4}>
                    <div><span>今日出账(元)</span></div>
                    <Row align='middle' style={{ marginTop: 10 }}>
                        <span style={{ fontSize: 24, fontWeight: 500 }}>{data && data.freezenBalance}</span>
                    </Row>
                </Col> */}
            </Row>
            <Row align='middle' style={{ padding: 16, paddingTop: 0, borderBottom: '1px solid #EBEDF0' }}>
                <Row align='middle' justify='space-between' style={{ padding: '10px 10px', width: '100%', height: '100%', background: '#F7F8FA' }}>
                    <Row align='middle' >
                        <div style={{ background: '#145BD5', height: 14, width: 3, }}></div><div style={{ marginLeft: 10, fontWeight: 500 }}>最近收支记录</div>
                    </Row>

                    <Col>
                        <Button type='link'
                            onClick={() => {
                                navigate('/ws/statementList', { replace: false, state: { accountType: '5', tag: 1, } })

                            }}
                        >全部收支记录</Button>
                    </Col>
                </Row>
            </Row>
            <Row style={{ padding: "0px 16px", marginTop: 10 }}>
                <Tabs onChange={onChange} type="card" defaultValue="">
                    <TabPane tab="全部" key="">
                    </TabPane>
                    <TabPane tab="收益" key="1">
                    </TabPane>
                    <TabPane tab="提现" key="2">
                    </TabPane>
                    <TabPane tab="手续费" key="3">
                    </TabPane>
                </Tabs>
            </Row>
            <Row style={{ padding: "0px 10px" }}>
                <Col span={24}>
                    <Table
                        locale={{
                            emptyText: "没有更多数据了"
                        }}
                        rowKey='id'
                        columns={columns}
                        dataSource={list}
                        pagination={false}
                    />
                </Col>

            </Row>
            <Modal title="选择还款方式" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <Radio.Group onChange={radioChange} value={radioValue}>
                    <Space direction="vertical">
                        <div>
                            <Radio value={1}><span>可用店铺余额(¥19999.00)</span><span style={{ color: '#D70000', marginLeft: 100 }}>余额不足</span></Radio>
                        </div>

                        <Radio value={2}>在线支付</Radio>
                    </Space>
                </Radio.Group>
                <div>图片</div>
            </Modal>
        </div >

    )
}
export default StoreValue;
